<template>
  <PageTemplate title="Parceiros">
    <LoadingWidget v-if="loading" />
    <transition name="fade">
      <div
        class="d-flex justify-center flex-wrap item-container"
        v-if="items && items.length && !loading"
      >
        <div
          v-for="({ img, title, link }, i) in items"
          :key="i"
          cols="6"
          md="2"
          class="item"
        >
          <a :title="title" v-if="link" target="_blank" :href="link">
            <img width="100%" class="d-block" :src="img" :alt="title" />
          </a>
          <div :title="title" v-else>
            <img width="100%" class="d-block" :src="img" :alt="title" />
          </div>
        </div>
      </div>
      <v-alert v-else-if="!loading" type="info" width="100%">
        Nenhum conteúdo adicionado até o momento.
      </v-alert>
    </transition>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";

const _config = {
  mod: "partners",
};
export default {
  data: () => ({
    loading: true,
  }),
  components: { PageTemplate, LoadingWidget },
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ title, img, link }) => ({
        title,
        img: this.files + img + `?resize=1&w=500`,
        link,
      }));
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
};
</script>

<style lang="scss" scoped>
.item-container {
  gap: 50px;
  @media (max-width: 600px) {
    gap: 25px;
  }
}
.item img {
  aspect-ratio: 1/1;
  object-fit: contain;
  height: 120px;
}
</style>
